
import he from './locales/he.json';


export default {
    he: he
}